import groupModule from "../groupModule";

function groupAffiliatesController($scope, $filter, groupsConstants, groupDetailsConstants, cursorPaginationService, $q, $log) {
    "ngInject";

    var ctrl = this;

    var init = function () {
        $scope.affiliatesPager.loadFirstPage();
    };

    $scope.affiliatesPager = cursorPaginationService.createPager({
        cursorName: "startRowIndex",
        limitName: "maxRows",
        firstPageCursor: "0",

        pageSize: groupDetailsConstants.affiliatesPageSize,
        loadPageSize: groupDetailsConstants.cursorPageLoadSize,

        getCacheKeyParameters: function () {
            return {
                groupId: ctrl.groupId,
                groupRelationshipType: ctrl.relationshipType
            };
        },

        getRequestUrl: function () {
            return $filter("formatString")(groupsConstants.urls.getGroupRelationships, {
                groupId: ctrl.groupId,
                groupRelationshipType: ctrl.relationshipType
            });
        },

        getNextPageCursorFromResponse: function (response) {
            if (!response.nextRowIndex || response.totalGroupCount <= response.nextRowIndex) {
                return null;
            }

            return response.nextRowIndex.toString();
        },

        getDataListFromResponse: function (response) {
            return $q(function (resolve, reject) {
                resolve(response.relatedGroups);
            });
        },

        loadSuccess: function (groups) {
            ctrl.affiliates = groups;
        },

        loadError: function (errors) {
            ctrl.affiliates = [];
            ctrl.loadAffiliatesError = true;
            $log.debug(" ------ getGroupRelationships error -------");
        }
    });

    ctrl.$onInit = init;
}

groupModule.controller("groupAffiliatesController", groupAffiliatesController);
export default groupAffiliatesController;